import { createApp } from 'vue'
import App from './App.vue'
import router from './router/index'
import "./assets/css/style.css"
// import installElementPlus from './plugins/element'
import ElementPlus from 'element-plus'
import 'element-plus/lib/theme-chalk/index.css'
import localeZH from 'element-plus/lib/locale/lang/zh-cn'
import localeEN from 'element-plus/lib/locale/lang/en'
//视频插件
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')

//阿里图库
import "./assets/font/iconfont.css"; 
import store from './store'
//轮播图
import SwiperCore, {
    Navigation,
    Pagination,
    Scrollbar,
    A11y,
    Autoplay,
  } from "swiper";
  SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay]);
  


//注意use要在mount之前
createApp(App).use(store).use(router).use(VideoPlayer).use(ElementPlus).use(store).mount('#app')